import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { EstablishmentService } from '../../../services/establishment.service';
import { Establishment } from '../../../models/Establishment';
import { ActivatedRoute } from '@angular/router';
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {SharedModule} from "../../../shared/shared.module";
import {EtablissementModule} from "../../../pages/etablissement/etablissement.module";

@Component({
  selector: 'app-agency-establishment-edit',
  templateUrl: './agency-establishment-edit.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatTabGroup,
    MatTab,
    SharedModule,
    EtablissementModule
  ],
  standalone: true
})
export class AgencyEstablishmentEditComponent implements OnInit {
  establishment: Establishment;
  id: number;

  constructor(
    private establishmentService: EstablishmentService,
    private route: ActivatedRoute
  ) {
    this.id = +this.route.snapshot.params['id'];
    localStorage.setItem('temp_id', this.id.toString())
  }

  ngOnInit() {
    this.getEstablishment();
  }

  getEstablishment() {
    this.establishmentService.getEstablishmentByIdV2(this.id).subscribe({
      next: (res) => {
        this.establishment = res;
      },
      error: () => {},
      complete: () => {},
    });
  }

  refreshData() {
    this.getEstablishment();
  }
}
